import { useCallback, useState } from 'react';

import { LeavePageContext } from '@app/providers/LeavePageProvider/LeavePageContext';
import type { NLeavePageProvider } from '@app/providers/LeavePageProvider/LeavePageProvider.types';
import { findSidebarParentKey } from '@app/utils';

export const LeavePageProvider: NLeavePageProvider.Main = ({ children }) => {
  const [initialData, setInitialData] = useState([]);
  const [newData, setNewData] = useState({});

  const prepareStartedData = useCallback((data: NLeavePageProvider.Data) => {
    setNewData(data);
    setInitialData(data);
  }, []);

  const setInputData = ({
    event,
    fieldName,
    isEditPage,
    isTextField,
  }: NLeavePageProvider.SetInputData) => {
    // Если в модели, приходящей с бэка поле имеет тип integer, то пустое значение будет null,
    // для текстового поля - ''. Если пресета модели не происходит (в случае создания сущности)
    // для всех полей текстовых компонентов дефолтное значение - undefined
    const defaultValue = isEditPage ? (isTextField ? '' : null) : undefined;

    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: event.target.value.length
          ? event.target.value
          : defaultValue,
      };
    });
  };

  const setPhoneCountryIdForLeavePageProvider = ({
    fieldName,
    id,
  }: NLeavePageProvider.SetPhoneCountryId) => {
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: id,
      };
    });
  };

  const setPhoneNumberBody = ({
    fieldName,
    value,
  }: NLeavePageProvider.SetPhoneNumberBody) => {
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
  };

  const setSelectorData = ({
    value,
    fieldName,
  }: NLeavePageProvider.SetSelectorData) => {
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
  };

  const setCheckboxData = ({
    event,
    fieldName,
    isEditPage,
  }: NLeavePageProvider.SetCheckboxData) => {
    const defaultValue = isEditPage ? false : undefined;
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: event.target.checked ? event.target.checked : defaultValue,
      };
    });
  };

  const setDatePickerData = ({
    dateString,
    fieldName,
  }: NLeavePageProvider.SetDatePickerData) => {
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: dateString,
      };
    });
  };

  const setSwitchData = ({
    fieldName,
    value,
  }: NLeavePageProvider.SetSwitchData) => {
    setNewData((prev: NLeavePageProvider.Data) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
  };

  const checkIsDataUpdated = ({
    path,
    navigate,
  }: NLeavePageProvider.CheckIsDataUpdated) => {
    prepareStartedData({});
    navigate(path);
    return true;
  };

  const handleMenuClick = ({
    key,
    navigateToPage,
    setPageKey,
  }: NLeavePageProvider.HandleMenuClick) => {
    navigateToPage(key);
    setPageKey(findSidebarParentKey(key) || '');
  };

  return (
    <LeavePageContext.Provider
      value={{
        initialData,
        newData,
        startedData: [],
        setInitialData,
        setNewData,
        prepareStartedData,
        checkIsDataUpdated,
        handleMenuClick,
        setInputData,
        setSelectorData,
        setCheckboxData,
        setDatePickerData,
        setSwitchData,
        setPhoneCountryIdForLeavePageProvider,
        setPhoneNumberBody,
      }}
    >
      {children}
    </LeavePageContext.Provider>
  );
};
